import { $, $$ } from '../../../shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';

const accordions = $$('.accordion');

const initAccordions = accordions => {
  const accordionInstances = [];

  accordions.forEach(accordion => {
    const items = $$('.accordion__item', accordion);

    items.forEach(item => {
      const handler = $('.accordion__button', item);
      const target = $('.accordion__content', item);
      const targetInner = target
        ? $('.accordion__content-inner', target)
        : false;

      const config =
        item.dataset.accordionConfig &&
        JSON.parse(item.dataset.accordionConfig?.replaceAll("'", '"'));

      if (!handler || !target || !targetInner) return;

      const accordionInstance = new Accordion({
        handler,
        target,
        targetInner,
        ...config,
      });

      accordionInstances.push(accordionInstance);
      accordionInstance.init();
    });
  });

  return accordionInstances;
};
/* eslint-disable no-unused-vars */
const accordionInstances = initAccordions(accordions);
/* eslint-enable no-unused-vars */

export { initAccordions };
